import { Header } from "@sablier/v2-components/molecules";
import { routes } from "@sablier/v2-constants";
import { useT } from "@sablier/v2-locales";

const path = [
  {
    title: routes.client.pages.dashboard.title,
    toPage: routes.client.pages.dashboard.builder(),
  },
  {
    title: routes.client.pages.galleryGroup.title,
    toPage: routes.client.pages.galleryGroup.builder(),
  },
  { title: routes.client.pages.createGroup.title },
];

function Top() {
  const { t } = useT();
  return (
    <Header
      back={path[1].toPage}
      path={path}
      title={t("structs.createGroup")}
    />
  );
}

export default Top;
